
export class ApplicantController {

    isProduction;

    static $inject = ['$rootScope', 'environment', 'ApplicationStatus', 'Auth', 'style']
    constructor($rootScope, environment, ApplicationStatus, Auth, style) {

        this.isProduction = environment.isProduction;
    }
}